define([
	"dojo/_base/declare",
	"csi/heading/Url"
], function(declare,Url) {

	return declare(Url, {
		_getPdfTitle: function(/*Context*/ctx) {
			// summary: return title containing data sheet name and revision
			var rev = ctx.getNode();
			var master = ctx.getNodeParent();
			return (master ? (master.$Name + " - ") : "") + rev.$Name;
		}
	});
});